import React, { useEffect, useRef, useState } from 'react';
import './WhyChooseSalesTology.css';
import chooseImage from "../../assests/salestology-img09.webp";

const WhyChooseSalesTology = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

    const whyChoose = {
        backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${chooseImage})`
    };

  return (
    <>
      <section className="why-choose-section" ref={sectionRef} style={whyChoose}>
        <div className="why-choose-container">
          <h2 className={`choose-title ${isVisible ? 'animate' : ''}`}>
            Why Choose SalesTology
          </h2>
          
          <div className="cards-container">
            <div className={`info-card ${isVisible ? 'animate' : ''}`}>
              <div className="card-header">
                <h3 className="cardchoose-title">Walked in your shoes | <span className="card-subtitle"> Extensive experience in</span></h3>
              </div>
              <ul className="card-list experience-points">
                <li>A. Building sales and distribution channel capabilities</li>
                <li>B. Growing sales in Industrials and Life Sciences</li>
              </ul>
            </div>

            <div className={`info-card ${isVisible ? 'animate' : ''}`}>
              <div className="card-header">
                <h3 className="card-subtitle">Focus on <span className="highlight">adoption</span> of new technologies, processes and behavior through <span className="highlight">Change Management</span> methods. Will meet you where you are!!</h3>
              </div>
              <ul className="card-list">
                <li>Sales Leaders</li>
                <li>Sales Managers</li>
                <li>Sales Professionals</li>
              </ul>
            </div>

            <div className={`info-card ${isVisible ? 'animate' : ''}`}>
              <div className="card-header">
                <h3 className="cardchoose-title">Cost effective</h3>
              </div>
              <div className="card-contents">
                <p>Our pragmatic methodology aims to move through the process efficiently. We don't waste time on gimmicks, but rather on straight forward process and solutions.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseSalesTology;